/**
 @author xiaoye
 @date 2020/4/9 4:06 下午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

let loginToken = null;
export const getLogin = async (data) => {
    if (loginToken) {
        loginToken.cancel({status: 'cancel'});
    }
    loginToken = axios.token();
    return axios.ajax({
        url: baseUrl.xy[0] + "/Login",
        method: "post",
        data: data,
        token: loginToken.token,
        token_key: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

// 验证手机号
export const VerifPhone = async (data) => {
    return axios.ajax({
        url: baseUrl.xy[0] + "/VerifPhone?"+qs.stringify(data),
        method: "get",
    })
};

// 验证码
export const VerificationCode = async (data) => {
    return axios.ajax({
        url: baseUrl.xy[0] + "/VerificationCode?"+qs.stringify(data),
        method: "get",
    })
};
// 注册
export const RegistrationUser = async (data) => {
    return axios.ajax({
        url: baseUrl.xy[0] + "/RegistrationUser",
        method: "post",
        data:data,
        isNoQS:true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }

    })
};
//忘记密码
export const EditPwd = async (data) => {
    if (loginToken) {
        loginToken.cancel({status: 'cancel'});
    }
    loginToken = axios.token();
    return axios.ajax({
        url: baseUrl.xy[0] + "/EditPwd",
        method: "post",
        data: data,
        token: loginToken.token,
        token_key: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};